export const APPLICATION_NAME = 'VIN Decoder';
